import { useQueryClient } from "@tanstack/react-query"

import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { invalidateDocumentsList, invalidateDocumentProject, invalidateAttachedObject } from "../cacheUtils"
import { documentQueryKeys } from "../queries/queryKeys"

import { useDocumentMutation } from "./useDocumentMutation"

export function useDocumentDelete(
    document,
    queryParameters,
    config = {},
) {
    const url = `documents/${document?.uuid}/`
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    return useDocumentMutation(
        url,
        axiosInstance.delete,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: documentQueryKeys.detail(document.uuid) })
                queryClient.invalidateQueries({ queryKey: documentQueryKeys.authors() })

                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)
                invalidateAttachedObject(queryClient, document)

                config.onSuccess?.(data)
            },
        },
    )
}
